export const NO_OP_MESSAGE__ANDROID =
  'module is No-op on web; Only relevant in android apps.';
export const NO_OP_MESSAGE__NATIVE =
  'module is No-op on web; Only relevant in native apps.';
